import React from 'react';

import { fontFamilyOptions } from '../../../Services/Fonts';
import UISelect from '../../UIComponents/UISelect';

interface FontFamilySelectProps {
  value: string | null | undefined;
  onSelect: (fontFamily: string | null | undefined) => void;
}

const FontFamilySelect = ({ value, onSelect }: FontFamilySelectProps) => (
  <UISelect
    value={value}
    handleSelect={onSelect}
    options={fontFamilyOptions}
    placeholder="Select font family"
  />
);

export default FontFamilySelect;
